class Logger {
  public log(message: any) {
    console.log(message);
  }

  public info(message: any) {
    console.info(`[${new Date().toISOString().slice(11, 19)} INF] %c${message}`, 'color: green');
  }

  public error(message: any) {
    if ('message' in message) {
      console.info(`[${new Date().toISOString().slice(11, 19)} ERR] %c${message.message}`, 'color: red');
    } else {
      console.info(`[${new Date().toISOString().slice(11, 19)} ERR] %c${message}`, 'color: red');
    }
  }

  public warn(message: any) {
    console.info(`[${new Date().toISOString().slice(11, 19)} WAR] %c${message}`, 'color: orange');
  }
}

export const logger = new Logger();
